interface CarouselItem {
  image: string;
  title: string;
  subtitle: string;
  desc: string;
  tag: string;
}

const carouselItems: CarouselItem[] = [
  {
    image: "https://readdy.ai/api/search-image?query=Epic%20historical%20Chinese%20drama%20scene%20with%20palace%20and%20warriors%2C%20golden%20sunset%20lighting%2C%20grand%20cinematic%20composition%2C%20warm%20dramatic%20tones%2C%20stylized%20movie%20poster%20style%2C%20clean%20illustration&width=700&height=420&seq=carousel-01&orientation=landscape",
    title: '暑期档必追',
    subtitle: '古装权谋巅峰之作',
    desc: '宫廷风云变幻，朝堂之上暗流涌动，一场关乎江山社稷的博弈正在展开。48集巨制，每一帧都是视觉盛宴。',
    tag: '热门专题',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Mystery%20thriller%20drama%20scene%2C%20dark%20rainy%20city%20with%20detective%20silhouette%2C%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20suspenseful%20cinematic%20atmosphere%2C%20warm%20orange%20accents%2C%20stylized%20illustration&width=700&height=420&seq=carousel-02&orientation=landscape",
    title: '悬疑剧迷专场',
    subtitle: '烧脑反转停不下来',
    desc: '从连环命案到心理博弈，每一部都是智商在线的精品。当你以为猜到结局时，真正的反转才刚刚开始。',
    tag: '编辑精选',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Korean%20drama%20romance%20scene%2C%20cherry%20blossom%20street%20with%20couple%2C%20soft%20warm%20spring%20lighting%2C%20dreamy%20cinematic%20atmosphere%2C%20stylized%20Korean%20drama%20poster%20style%2C%20gentle%20pastel%20tones&width=700&height=420&seq=carousel-03&orientation=landscape",
    title: '韩剧浪漫特辑',
    subtitle: '甜到心坎里的爱情故事',
    desc: '精选年度高分韩剧，从奇幻穿越到现实治愈，每一部都让人心动不已。准备好纸巾，糖分警告！',
    tag: '浪漫特辑',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Science%20fiction%20futuristic%20scene%2C%20digital%20city%20with%20holograms%2C%20cyberpunk%20aesthetic%2C%20dark%20and%20mysterious%20atmosphere%2C%20warm%20orange%20glowing%20accents%2C%20stylized%20movie%20poster%2C%20clean%20composition&width=700&height=420&seq=carousel-04&orientation=landscape",
    title: '科幻迷的盛宴',
    subtitle: '硬核烧脑科幻大作',
    desc: '虚拟现实、人工智能、平行宇宙……这些科幻神作将带你突破想象的边界，探索未知的可能性。',
    tag: '科幻专场',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20scene%20with%20epic%20battle%2C%20dynamic%20character%20poses%2C%20colorful%20energy%20effects%2C%20dramatic%20lighting%2C%20stylized%20Japanese%20anime%20movie%20poster%2C%20warm%20vibrant%20colors&width=700&height=420&seq=carousel-05&orientation=landscape",
    title: '动漫热血专场',
    subtitle: '燃到炸裂的动画神作',
    desc: '从日漫经典到国漫新秀，精选高分动画作品。热血战斗、治愈日常、奇幻冒险，总有一部让你上头。',
    tag: '动漫专场',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20scene%2C%20young%20professionals%20in%20city%20at%20sunset%2C%20warm%20golden%20lighting%2C%20contemporary%20lifestyle%20aesthetic%2C%20stylized%20illustration%2C%20clean%20modern%20composition%2C%20warm%20tones&width=700&height=420&seq=carousel-06&orientation=landscape",
    title: '都市情感剧场',
    subtitle: '真实戳心的生活写照',
    desc: '聚焦都市青年的职场奋斗、情感纠葛与成长蜕变。这些故事里，总有一个角色让你看到自己的影子。',
    tag: '生活剧场',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          精选专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">为你精心策划的追剧专题，发现更多好剧</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[5/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="700"
                  height="420"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 text-[10px] font-bold px-2.5 py-1 rounded bg-accent-500 text-background-50 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="font-heading text-base text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-primary-600 font-medium mb-2">{item.subtitle}</p>
                <p className="text-xs text-foreground-500 leading-relaxed flex-1">{item.desc}</p>
                <div className="mt-3 pt-3 border-t border-background-200/50 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{idx + 1} / {carouselItems.length}</span>
                  <span className="text-xs text-primary-600 font-medium whitespace-nowrap">
                    查看详情 <i className="ri-arrow-right-line ml-0.5"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}